import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//

import { themesMixin } from '../../../utils/themes';
import { mapsMixin } from '../../../utils/maps';
export default {
  name: 'CoreChartAlarmTable',
  mixins: [mapsMixin, themesMixin],
  props: {
    size: {
      type: Number,
      "default": 0
    },
    width: {
      type: Number,
      "default": 0
    },
    border: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      lclAlertTable: [{
        dtwin: 'Raum 191: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 177: 27°C',
        value: '28°C'
      }, {
        dtwin: 'Raum 003: 27°C',
        value: '26°C'
      }, {
        dtwin: 'Raum 142: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 111: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 177: 27°C',
        value: '28°C'
      }, {
        dtwin: 'Raum 003: 27°C',
        value: '26°C'
      }, {
        dtwin: 'Raum 142: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 111: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 177: 27°C',
        value: '28°C'
      }, {
        dtwin: 'Raum 003: 27°C',
        value: '26°C'
      }, {
        dtwin: 'Raum 142: 27°C',
        value: 'Raum 27°C'
      }, {
        dtwin: 'Raum 111: 27°C',
        value: '27°C'
      }]
    };
  },
  computed: {
    color: function color() {
      return this.vuetifyColorHex();
    },
    drawSize: function drawSize() {
      return this.size ? "".concat(this.size, "px") : '100%';
    },
    drawWidth: function drawWidth() {
      return this.width ? "".concat(this.width, "px") : '100%';
    },
    drawBorder: function drawBorder() {
      return this.border ? "1px solid ".concat(this.color) : 'none';
    }
  }
};